import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Modal,
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import LoadingSpinner from "views/Components/loadingSpinner";
import { style } from "../../../variables/Variables";
import {
  getClaimCsrFeedbackCustomers,
  revealClaimCsrFeedbackNumber,
  saveClaimCsrFeedback,
} from "../../../Listfunction";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
import "./claimCsrFeedback.css";

var emptyForm = {
  status: "pending",
  call_outcome: "",
  preferred_language: "",
  benefit_awareness: "",
  app_order_awareness: "",
  no_claim_reason: "",
  main_barrier: "",
  medicine_buying_frequency: "",
  monthly_medicine_spend: "",
  expected_monthly_order_value: "",
  conversion_priority: "",
  current_pharmacy: "",
  primary_condition: "",
  has_prescription: "",
  interested_in_flash_order: "",
  free_delivery_interest: "",
  wants_cs_callback: "",
  preferred_channel: "",
  next_action: "",
  callback_at: "",
  notes: "",
};

class ClaimCsrFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      revealingId: null,
      customers: [],
      statuses: {},
      stats: {
        total: 0,
        pending: 0,
        interested: 0,
        follow_up: 0,
        closed: 0,
        has_orders: 0,
        no_orders: 0,
        my_calls: 0,
      },
      search: "",
      status: "",
      order_segment: "",
      contacted_by: "",
      district: "",
      districtOptions: [],
      currentPage: 1,
      lastPage: 1,
      revealedNumbers: {},
      selectedCustomer: null,
      feedbackForm: Object.assign({}, emptyForm),
    };

    this.loadCustomers = this.loadCustomers.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.goToPage = this.goToPage.bind(this);
    this.revealNumber = this.revealNumber.bind(this);
    this.openFeedback = this.openFeedback.bind(this);
    this.closeFeedback = this.closeFeedback.bind(this);
    this.handleFeedbackChange = this.handleFeedbackChange.bind(this);
    this.saveFeedback = this.saveFeedback.bind(this);
  }

  componentDidMount() {
    this.setState(
      {
        _notificationSystem: this.refs.notificationSystem,
      },
      () => {
        this.loadCustomers(1);
      },
    );
  }

  getToken() {
    var token = JSON.parse(localStorage.getItem("user"));
    return token ? token.token : "";
  }

  notify(level, message) {
    if (!this.state._notificationSystem) {
      return;
    }

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-call"></span>,
      message: <div>{message}</div>,
      level: level,
      position: "tr",
      autoDismiss: 7,
    });
  }

  handleNetworkError(error) {
    this.notify("error", getApiErrorMessage(error));
  }

  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleFeedbackChange(event) {
    var feedbackForm = Object.assign({}, this.state.feedbackForm);
    feedbackForm[event.target.name] = event.target.value;
    this.setState({ feedbackForm: feedbackForm });
  }

  loadCustomers(page) {
    var obj = this.getToken();
    this.setState({ loading: true });

    getClaimCsrFeedbackCustomers(obj, {
      search: this.state.search,
      status: this.state.status,
      order_segment: this.state.order_segment,
      contacted_by: this.state.contacted_by,
      district: this.state.district,
      page: page || this.state.currentPage,
      records_per_page: 20,
    })
      .then((response) => {
        if (!response.success) {
          this.notify("error", response.message || "Unable to load customers.");
          this.setState({ loading: false });
          return;
        }

        var payload = response.data || {};
        var customers = payload.customers || {};

        this.setState({
          customers: customers.data || [],
          statuses: payload.statuses || {},
          stats: payload.stats || this.state.stats,
          districtOptions:
            payload.filters && payload.filters.district_options
              ? payload.filters.district_options
              : [],
          currentPage: customers.current_page || 1,
          lastPage: customers.last_page || 1,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.handleNetworkError(error);
      });
  }

  applyFilters() {
    this.loadCustomers(1);
  }

  resetFilters() {
    this.setState(
      {
        search: "",
        status: "",
        order_segment: "",
        contacted_by: "",
        district: "",
      },
      () => this.loadCustomers(1),
    );
  }

  goToPage(page) {
    if (page < 1 || page > this.state.lastPage || page === this.state.currentPage) {
      return;
    }
    this.loadCustomers(page);
  }

  revealNumber(customer) {
    var obj = this.getToken();
    this.setState({ revealingId: customer.lead_id });

    revealClaimCsrFeedbackNumber(customer.lead_id, obj)
      .then((response) => {
        if (!response.success) {
          this.notify("error", response.message || "Unable to reveal number.");
          this.setState({ revealingId: null });
          return;
        }

        var revealedNumbers = Object.assign({}, this.state.revealedNumbers);
        revealedNumbers[customer.lead_id] = response.data.mobile_no;

        this.setState({
          revealedNumbers: revealedNumbers,
          revealingId: null,
        });
      })
      .catch((error) => {
        this.setState({ revealingId: null });
        this.handleNetworkError(error);
      });
  }

  openFeedback(customer) {
    var feedbackForm = Object.assign({}, emptyForm, {
      status: customer.status || "pending",
      call_outcome: customer.call_outcome || "",
      preferred_language: customer.preferred_language || "",
      benefit_awareness: customer.benefit_awareness || "",
      app_order_awareness: customer.app_order_awareness || "",
      no_claim_reason: customer.no_claim_reason || "",
      main_barrier: customer.main_barrier || "",
      medicine_buying_frequency: customer.medicine_buying_frequency || "",
      monthly_medicine_spend: customer.monthly_medicine_spend || "",
      expected_monthly_order_value: customer.expected_monthly_order_value || "",
      conversion_priority: customer.conversion_priority || "",
      current_pharmacy: customer.current_pharmacy || "",
      primary_condition: customer.primary_condition || "",
      has_prescription: this.booleanToSelect(customer.has_prescription),
      interested_in_flash_order: this.booleanToSelect(
        customer.interested_in_flash_order,
      ),
      free_delivery_interest: this.booleanToSelect(customer.free_delivery_interest),
      wants_cs_callback: this.booleanToSelect(customer.wants_cs_callback),
      preferred_channel: customer.preferred_channel || "",
      next_action: customer.next_action || "",
      callback_at: this.formatDateTimeLocal(customer.callback_at),
      notes: customer.notes || "",
    });

    this.setState({
      selectedCustomer: customer,
      feedbackForm: feedbackForm,
    });
  }

  closeFeedback() {
    this.setState({
      selectedCustomer: null,
      feedbackForm: Object.assign({}, emptyForm),
    });
  }

  booleanToSelect(value) {
    if (value === true || value === 1 || value === "1") {
      return "1";
    }
    if (value === false || value === 0 || value === "0") {
      return "0";
    }
    return "";
  }

  normalizeBoolean(value) {
    if (value === "1") {
      return true;
    }
    if (value === "0") {
      return false;
    }
    return null;
  }

  formatDateTimeLocal(value) {
    if (!value) {
      return "";
    }
    return String(value).replace(" ", "T").slice(0, 16);
  }

  saveFeedback() {
    if (!this.state.selectedCustomer) {
      return;
    }

    var obj = this.getToken();
    var form = this.state.feedbackForm;
    var payload = Object.assign({}, form, {
      has_prescription: this.normalizeBoolean(form.has_prescription),
      interested_in_flash_order: this.normalizeBoolean(
        form.interested_in_flash_order,
      ),
      free_delivery_interest: this.normalizeBoolean(form.free_delivery_interest),
      wants_cs_callback: this.normalizeBoolean(form.wants_cs_callback),
    });

    this.setState({ saving: true });

    saveClaimCsrFeedback(this.state.selectedCustomer.lead_id, payload, obj)
      .then((response) => {
        if (!response.success) {
          this.notify("error", response.message || "Unable to save feedback.");
          this.setState({ saving: false });
          return;
        }

        this.notify("success", "Feedback saved.");
        this.setState(
          {
            saving: false,
            selectedCustomer: null,
            feedbackForm: Object.assign({}, emptyForm),
          },
          () => this.loadCustomers(this.state.currentPage),
        );
      })
      .catch((error) => {
        this.setState({ saving: false });
        this.handleNetworkError(error);
      });
  }

  renderStatusOptions() {
    var statuses = this.state.statuses || {};
    return Object.keys(statuses).map((key) => (
      <option value={key} key={key}>
        {statuses[key]}
      </option>
    ));
  }

  renderStatCard(label, value, tone, orderSegment, contactedBy) {
    var quickStatus = {
      pending: "pending",
      interested: "interested",
      "follow-up": "follow_up",
      closed: "closed",
    }[tone || ""];

    return (
      <Col md={2} sm={4} xs={6}>
        <button
          type="button"
          className={"csr-stat-card " + (tone || "")}
          onClick={() => {
            this.setState(
              {
                status: quickStatus || "",
                order_segment: orderSegment || "",
                contacted_by: contactedBy || "",
              },
              () => this.loadCustomers(1),
            );
          }}
        >
          <span>{label}</span>
          <strong>{value || 0}</strong>
        </button>
      </Col>
    );
  }

  renderRows() {
    if (this.state.loading) {
      return (
        <tr>
          <td colSpan="10">
            <LoadingSpinner />
          </td>
        </tr>
      );
    }

    if (!this.state.customers.length) {
      return (
        <tr>
          <td colSpan="10" className="text-center muted-cell">
            No customers found for these filters.
          </td>
        </tr>
      );
    }

    return this.state.customers.map((customer) => {
      var revealed = this.state.revealedNumbers[customer.lead_id];
      return (
        <tr key={customer.lead_id}>
          <td>
            <strong>{customer.name || "-"}</strong>
            <span>{customer.company_name || "No company"}</span>
          </td>
          <td>
            <strong>{revealed || customer.masked_mobile_no}</strong>
            <span>{customer.district || "No district"}</span>
          </td>
          <td>
            <span className={"csr-status-pill " + customer.status}>
              {this.state.statuses[customer.status] || customer.status}
            </span>
            <span>{customer.call_outcome || "Not called yet"}</span>
          </td>
          <td>
            <strong>{customer.order_segment || "-"}</strong>
            <span>{customer.total_orders || 0} orders</span>
          </td>
          <td>{customer.last_order_at || "-"}</td>
          <td>{customer.no_claim_reason || "-"}</td>
          <td>{customer.next_action || "-"}</td>
          <td>{customer.call_attempts || 0}</td>
          <td>{customer.last_called_at || "-"}</td>
          <td className="csr-actions">
            <Button
              bsStyle="info"
              simple
              onClick={() => this.revealNumber(customer)}
              disabled={this.state.revealingId === customer.lead_id}
            >
              {revealed ? "Shown" : "Reveal"}
            </Button>
            <Button bsStyle="primary" onClick={() => this.openFeedback(customer)}>
              Feedback
            </Button>
          </td>
        </tr>
      );
    });
  }

  renderFeedbackModal() {
    var customer = this.state.selectedCustomer;
    var form = this.state.feedbackForm;

    return (
      <Modal
        show={!!customer}
        onHide={this.closeFeedback}
        dialogClassName="csr-feedback-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            CSR feedback {customer ? "- " + (customer.name || "Customer") : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Call status</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="status"
                  value={form.status}
                  onChange={this.handleFeedbackChange}
                >
                  {this.renderStatusOptions()}
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Call outcome</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="call_outcome"
                  value={form.call_outcome}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select outcome</option>
                  <option value="Answered">Answered</option>
                  <option value="No answer">No answer</option>
                  <option value="Busy">Busy</option>
                  <option value="Switched off">Switched off</option>
                  <option value="Wrong number">Wrong number</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Preferred language</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="preferred_language"
                  value={form.preferred_language}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select language</option>
                  <option value="Sinhala">Sinhala</option>
                  <option value="Tamil">Tamil</option>
                  <option value="English">English</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Awareness of claim benefit</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="benefit_awareness"
                  value={form.benefit_awareness}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select answer</option>
                  <option value="Aware">Aware</option>
                  <option value="Not aware">Not aware</option>
                  <option value="Partially aware">Partially aware</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Knows how to place order</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="app_order_awareness"
                  value={form.app_order_awareness}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select answer</option>
                  <option value="Knows how to order">Knows how to order</option>
                  <option value="Needs order guidance">Needs order guidance</option>
                  <option value="Never used app">Never used app</option>
                  <option value="Prefers phone support">Prefers phone support</option>
                  <option value="Not interested in ordering">Not interested in ordering</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Reason for no claim</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="no_claim_reason"
                  value={form.no_claim_reason}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select reason</option>
                  <option value="Did not know how to claim">
                    Did not know how to claim
                  </option>
                  <option value="No recent medicine purchase">
                    No recent medicine purchase
                  </option>
                  <option value="Uses another pharmacy">Uses another pharmacy</option>
                  <option value="Claim process feels difficult">
                    Claim process feels difficult
                  </option>
                  <option value="Not interested">Not interested</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Main blocker</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="main_barrier"
                  value={form.main_barrier}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select blocker</option>
                  <option value="Does not know Flash Health">Does not know Flash Health</option>
                  <option value="Does not know order process">Does not know order process</option>
                  <option value="Does not know claim process">Does not know claim process</option>
                  <option value="Price concern">Price concern</option>
                  <option value="Delivery concern">Delivery concern</option>
                  <option value="Already has trusted pharmacy">Already has trusted pharmacy</option>
                  <option value="No current medicine need">No current medicine need</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Medicine buying frequency</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="medicine_buying_frequency"
                  value={form.medicine_buying_frequency}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select frequency</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Every 2-3 months">Every 2-3 months</option>
                  <option value="Only when sick">Only when sick</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Expected monthly order value</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="expected_monthly_order_value"
                  value={form.expected_monthly_order_value}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select value</option>
                  <option value="Below Rs. 2,500">Below Rs. 2,500</option>
                  <option value="Rs. 2,500 - 5,000">Rs. 2,500 - 5,000</option>
                  <option value="Rs. 5,000 - 10,000">Rs. 5,000 - 10,000</option>
                  <option value="Rs. 10,000+">Rs. 10,000+</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Monthly medicine spend</ControlLabel>
                <FormControl
                  name="monthly_medicine_spend"
                  value={form.monthly_medicine_spend}
                  onChange={this.handleFeedbackChange}
                  placeholder="Example: Rs. 5,000"
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Current pharmacy</ControlLabel>
                <FormControl
                  name="current_pharmacy"
                  value={form.current_pharmacy}
                  onChange={this.handleFeedbackChange}
                  placeholder="Where they buy medicine"
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Primary condition</ControlLabel>
                <FormControl
                  name="primary_condition"
                  value={form.primary_condition}
                  onChange={this.handleFeedbackChange}
                  placeholder="Diabetes, BP, gastric..."
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>Has prescription</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="has_prescription"
                  value={form.has_prescription}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Unknown</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>Interested in Flash order</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="interested_in_flash_order"
                  value={form.interested_in_flash_order}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Unknown</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>Free delivery interest</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="free_delivery_interest"
                  value={form.free_delivery_interest}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Unknown</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>Need team callback</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="wants_cs_callback"
                  value={form.wants_cs_callback}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Unknown</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>Preferred channel</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="preferred_channel"
                  value={form.preferred_channel}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select channel</option>
                  <option value="Call">Call</option>
                  <option value="WhatsApp">WhatsApp</option>
                  <option value="SMS">SMS</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>Conversion priority</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="conversion_priority"
                  value={form.conversion_priority}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select priority</option>
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>Next action</ControlLabel>
                <FormControl
                  componentClass="select"
                  name="next_action"
                  value={form.next_action}
                  onChange={this.handleFeedbackChange}
                >
                  <option value="">Select next action</option>
                  <option value="Send claim guide">Send claim guide</option>
                  <option value="Send order guide">Send order guide</option>
                  <option value="Create pharmacy order">Create pharmacy order</option>
                  <option value="Internal CS callback">Internal CS callback</option>
                  <option value="Call back later">Call back later</option>
                  <option value="Do not contact">Do not contact</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>Callback time</ControlLabel>
                <FormControl
                  type="datetime-local"
                  name="callback_at"
                  value={form.callback_at}
                  onChange={this.handleFeedbackChange}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <ControlLabel>Notes</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  rows="3"
                  name="notes"
                  value={form.notes}
                  onChange={this.handleFeedbackChange}
                  placeholder="Short CSR notes"
                />
              </FormGroup>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button simple onClick={this.closeFeedback}>
            Cancel
          </Button>
          <Button bsStyle="primary" onClick={this.saveFeedback} disabled={this.state.saving}>
            {this.state.saving ? "Saving..." : "Save feedback"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    var stats = this.state.stats || {};

    return (
      <div className="main-content claim-csr-feedback-page">
        <Grid fluid>
          <div className="csr-page-header">
            <div>
              <h4>Claim CSR Feedback</h4>
              <p>Claim customers prepared for pharmacy conversion and CSR follow-up.</p>
            </div>
          </div>

          <Row className="csr-stats-row">
            {this.renderStatCard("Total", stats.total, "")}
            {this.renderStatCard("Pending", stats.pending, "pending")}
            {this.renderStatCard("Interested", stats.interested, "interested")}
            {this.renderStatCard("Follow up", stats.follow_up, "follow-up")}
            {this.renderStatCard("Closed", stats.closed, "closed")}
            {this.renderStatCard("Has orders", stats.has_orders, "", "has_orders")}
            {this.renderStatCard("No orders", stats.no_orders, "", "no_orders")}
            {this.renderStatCard("My calls", stats.my_calls, "", "", "me")}
          </Row>

          <div className="csr-filter-panel">
            <Row>
              <Col md={3}>
                <FormGroup>
                  <ControlLabel>Search</ControlLabel>
                  <FormControl
                    name="search"
                    value={this.state.search}
                    onChange={this.handleInputChange}
                    placeholder="Name, mobile, company"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <ControlLabel>Status</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="status"
                    value={this.state.status}
                    onChange={this.handleInputChange}
                  >
                    <option value="">All statuses</option>
                    {this.renderStatusOptions()}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <ControlLabel>Customer type</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="order_segment"
                    value={this.state.order_segment}
                    onChange={this.handleInputChange}
                  >
                    <option value="">All claim customers</option>
                    <option value="has_orders">Has pharmacy orders</option>
                    <option value="no_orders">No pharmacy orders</option>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <ControlLabel>District</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="district"
                    value={this.state.district}
                    onChange={this.handleInputChange}
                  >
                    <option value="">All districts</option>
                    {this.state.districtOptions.map((district) => (
                      <option value={district} key={district}>
                        {district}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={12}>
                <div className="csr-filter-actions">
                  <Button bsStyle="primary" onClick={this.applyFilters}>
                    Apply
                  </Button>
                  <Button simple onClick={this.resetFilters}>
                    Reset
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <div className="csr-table-card">
            <div className="csr-table-toolbar">
              <span>
                Page {this.state.currentPage} of {this.state.lastPage}
              </span>
              <div>
                <Button
                  simple
                  disabled={this.state.currentPage <= 1}
                  onClick={() => this.goToPage(this.state.currentPage - 1)}
                >
                  Previous
                </Button>
                <Button
                  simple
                  disabled={this.state.currentPage >= this.state.lastPage}
                  onClick={() => this.goToPage(this.state.currentPage + 1)}
                >
                  Next
                </Button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table csr-feedback-table">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Mobile</th>
                    <th>Status</th>
                    <th>Customer type</th>
                    <th>Last order</th>
                    <th>Claim/order blocker</th>
                    <th>Next action</th>
                    <th>Attempts</th>
                    <th>Last call</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{this.renderRows()}</tbody>
              </table>
            </div>
          </div>
        </Grid>
        {this.renderFeedbackModal()}
        <NotificationSystem ref="notificationSystem" style={style} />
      </div>
    );
  }
}

export default ClaimCsrFeedback;
